import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-add',
  templateUrl: './icon-add.component.html',
  styleUrls: ['./icon-add.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconAddComponent {}
